import { render, staticRenderFns } from "./DeviceAverageRatingReviews.vue?vue&type=template&id=597c0dba&"
import script from "./DeviceAverageRatingReviews.vue?vue&type=script&lang=js&"
export * from "./DeviceAverageRatingReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('597c0dba')) {
      api.createRecord('597c0dba', component.options)
    } else {
      api.reload('597c0dba', component.options)
    }
    module.hot.accept("./DeviceAverageRatingReviews.vue?vue&type=template&id=597c0dba&", function () {
      api.rerender('597c0dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/devicereviews/DeviceAverageRatingReviews.vue"
export default component.exports